import { useToast } from '@playbooks/contexts';
import { Button } from '@playbooks/ui/components/button';
import { FieldLabel } from '@playbooks/ui/components/field';
import { cn } from '@playbooks/ui/lib/utils';

import * as Filestack from 'filestack-js';

const FilestackThumbnail = ({
	title = 'Thumbnail',
	value,
	dimensions = { width: 1, height: 1 },
	onChange,
	disabled = false,
	className = '',
}) => {
	const client = Filestack.init(process.env.NEXT_PUBLIC_FILESTACK_KEY);
	const toast = useToast();

	const options = {
		accept: ['image/*'],
		maxFiles: 1,
		minFiles: 1,
		imageMin: [480, 480] as [number, number],
		imageMax: [1600, 1600] as [number, number],
		imageDim: [1600, 1600] as [number, number],
		uploadInBackground: false,
		fromSources: ['local_file_system', 'googledrive', 'url'],
		onUploadDone: data => onUploadDone(data),
		onFileUploadFailed: e => toast.showError(e),
		transformations: {
			rotate: true,
			crop: {
				force: true,
				aspectRatio: dimensions.width / dimensions.height,
			},
		},
	};

	// Methods
	const onUploadDone = data => {
		onChange(data.filesUploaded[0]);
	};

	const onOpen = () => {
		client.picker(options).open();
	};

	// Theme
	const rootClassName = cn('flex-middle size-20 overflow-hidden rounded-panel border bg-surface-hover', className);

	// Render
	return (
		<div className='flex-start gap-8'>
			<div className={rootClassName}>
				{value && <img src={value} alt='Photo thumbnail' className='h-full w-full object-cover' />}
			</div>
			<div className='space-y-2'>
				<FieldLabel className='block'>{title}</FieldLabel>
				<Button type='button' variant='outline' size='xs' disabled={disabled} onClick={onOpen}>
					Upload
				</Button>
			</div>
		</div>
	);
};

export { FilestackThumbnail };

// https://www.filestack.com/docs/
// https://www.filestack.com/docs/uploads/pickers/web/
